const apiUrl = process.env.REACT_APP_API_BASE_URL;
export default async function fetchcity(){
    try {
        const response = await fetch(`${apiUrl}/api/cities/indexify`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        const data = await response.json();
        return data
      } catch (error) {
         return console.error("Error fetching City Names:", error);
      }
}